import { render } from "./TerminalSetup.vue?vue&type=template&id=813d3682&scoped=true"
import script from "./TerminalSetup.vue?vue&type=script&lang=js"
export * from "./TerminalSetup.vue?vue&type=script&lang=js"

import "./TerminalSetup.vue?vue&type=style&index=0&id=813d3682&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-813d3682"]])

export default __exports__